/**
 * Handle state for the connector tiles on the create order form
 */
import axios from "axios";

export default {
  namespaced: true,
  state: {
    activeConnectors: []
  },
  mutations: {
    setActiveConnectors (state, connectors) {
      state.activeConnectors = connectors;
    },
  },
  getters: {
    nameOfActiveConnectors: (state) => {
      let activeConnectors = {none: 'Don\'t upload translations to a connected service'}
      if(!state.activeConnectors){
        return activeConnectors;
      }
      state.activeConnectors.map(conn => {
        activeConnectors[conn.shortname] = conn.displayname;
      })
      activeConnectors['none'] = 'Don\'t upload translations to a connected service';
      return activeConnectors;
    },
  },
  actions: {
    async loadActiveConnectors ({commit}) {
      return axios('/create-order/active-connectors')
        .then(result =>{
          commit('setActiveConnectors', result.data.data);
        })
        .catch(e => console.error(e));
    }
  }
};
